<template>
<div class="web-view-collection">
  <div style="display:none">
    <div class="btn-box">
      <p class="box-title">税法税便问</p>
      <button class="btn-back" @click="goBack()">返回首页</button>
    </div>
    <div class="collectionTitle">
        收藏列表
    </div>
  </div>
  <div class="dataBox">
    <!--随便问 问答收藏-->
    <div class="scTitle">
        <div class="leftBlueBox"></div>
        <div class="scTitleName">我的收藏 一 随便问</div>
        <!--收起展开图片-->
        <div class="scHandle">
            <img @click="sqzkSBWHandle('close','closeDiv')" v-if="scSBWStatus=='open'" :src="sbwSortZK" alt="">
            <img @click="sqzkSBWHandle('open','openDiv')" v-if="scSBWStatus=='close'" :src="sbwSortSQ" alt="">
        </div>
        <!--批量删除-->
        <div></div>
    </div>
    <div :class="scSBWClass" class="componentDiv">
        <shoucangSBW />
    </div>

    <!--答疑库收藏-->
    <div class="scTitle">
        <div class="leftBlueBox"></div>
        <div class="scTitleName">我的收藏 一 答疑库</div>
        <!--收起展开图片-->
        <div class="scHandle">
            <img @click="sqzkSBWHandleDYK('close','closeDiv')" v-if="scDYKStatus=='open'" :src="sbwSortZK" alt="">
            <img @click="sqzkSBWHandleDYK('open','openDiv')" v-if="scDYKStatus=='close'" :src="sbwSortSQ" alt="">
        </div>
        <!--批量删除-->
        <div></div>
    </div>
    <div :class="scDYKClass" class="componentDiv">
        <shoucangDayi />
    </div>
  </div>
</div>
  
</template>

<script>
import shoucangSBW from './collectionSbw.vue'
import shoucangDayi from './collectionDayi.vue'


import sbwSortSQ from '@/assets/sbwSortSQ.png'
import sbwSortZK from '@/assets/sbwSortZK.png'


export default {
  name: 'collection',
  components:{
    shoucangSBW,
    shoucangDayi,
  },
  data () {
    return {
        sbwSortZK,
        sbwSortSQ,
        //随便问收藏是否展开状态 open-展开 close-收起
        scSBWStatus:'open',
        //答疑库收藏是否展开状态 open-展开 close-收起
        scDYKStatus:'open',
        //随便问收藏样式
        scSBWClass:'openDiv',
        //答疑库收藏样式
        scDYKClass:'openDiv',
        

    }
  },
  mounted () {
    
  },
  methods: {
    goBack() {
      window.history.go(-1)
    },
    //收起展开
    sqzkSBWHandle(openKey,classKey){
        this.scSBWStatus = openKey;
        this.scSBWClass = classKey;
    },
    //收起展开答疑库
    sqzkSBWHandleDYK(openKey,classKey){
        this.scDYKStatus = openKey;
        this.scDYKClass = classKey
    },
  }
}
</script>

<style scoped>
.content{
  height: calc(100vh - 50px);
}
.btn-box{
  width: 100%;
  line-height: 50px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.box-title{
  order: 1;
  padding-left: 20px;
}
.btn-back{
  /* position: fixed; */
  /* float: right; */
  width: auto;
  height: 30px;
  line-height: 30px;
  margin: 10px 15px;
  border-radius: 5px;
  border: 1px solid #eeeeee;
}


.collectionTitle{
    width:100%;
    height:50px;
    background: #11607b;
    line-height: 48px;
    text-align: center;
    color:#ffffff;
}
.dataBox{
  /*width:calc(100% - 40px);*/
    width:calc(100% - 0);
    box-sizing: border-box;
    /*margin:20px;*/
    margin-top:10px;
    background: #ffffff;
    border-radius:20px;
    
    /*padding:15px;*/
    padding:20px;
    overflow: hidden;
}

.scTitle{
    width:100%;
    height:48px;
    border-radius:10px 10px 0 0;
    background: #eff4fa;
    box-sizing: border-box;
    padding: 0 20px;
}
.leftBlueBox{
  width:4px;
  height:20px;
  background: #2270e6;
  margin-top:14px;
  float: left;
  margin-right:10px;
}
.scTitleName{
    width:300px;
    height:48px;
    line-height: 48px;
    text-align: left;
    float: left;
    /*color: #e53d4f;*/
    font-size:18p;
    color:222222;
    font-family:MicrosoftYaHei-Bold ;
    font-weight: 700;
}
.scHandle{
    width: 20px;
    height:48px;
    float: right;
}
.scHandle img{
    width:24px;
    height:24px;
    margin-top:12px;
}
.closeDiv{
    max-height: 1px;
    overflow: hidden;
}
.openDiv{
    max-height: 2222px;
}
.componentDiv{
    margin-bottom:20px ;
    transition: all 0.8s;
}
</style>